<template>
  <div id="app">
    <navbar></navbar>
    <div id="routerView">
      <router-view :key="$route.fullPath" />
    </div>
    <!-- <div style="width:100%;text-align:center" class="mb-5">
      <h4 class="mb-3" style="color:black">Enjoying Cabinet Maps?</h4>
      <a href="https://www.producthunt.com/posts/cabinet-maps?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-cabinet-maps" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=170532&theme=dark" alt="Cabinet Maps - Create and Share Maps that respect your Privacy | Product Hunt Embed" style="width: 250px; height: 54px;" width="250px" height="54px" /></a>    </div> -->
    <page-footer></page-footer>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import PageFooter from '@/components/PageFooter'

export default {
  components: {
    Navbar,
    PageFooter
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  color: #161616;
}

#routerView {
  margin-top: 20px;
  margin-bottom: 80px;
}
</style>
